import script from "./SocialButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialButtons.vue?vue&type=script&setup=true&lang=ts"

import "./SocialButtons.vue?vue&type=style&index=0&id=bb222cc6&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb222cc6"]])

export default __exports__